import * as React from "react";
import { WalletBalanceState, GetWalletBalanceAction } from "@payment-client/reducers/Wallet";

export type WalletBalanceContextValue = {
    setState: React.Dispatch<GetWalletBalanceAction>;
    state: WalletBalanceState;
    refetch: (walletName: string) => Promise<void>;
};

export const WalletBalanceContext = React.createContext<WalletBalanceContextValue>({
    state: {},
    setState: () => void 0,
    refetch: (): Promise<void> => Promise.resolve(),
});

if (__DEV__) {
    WalletBalanceContext.displayName = "WalletBalanceContext";
}
